import axios from "axios";
import { traduceAccessError } from "@/composables/error.js";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Yuzu-Key": import.meta.env.VITE_API_KEY,
  },
});

const useAxios = {
  async get(path, params) {
    try {
      const response = await axiosInstance.get(`${path}`, {
        params,
      });

      return response;
    } catch (error) {
      if (error.response) traduceAccessError(error.response.data);

      throw error;
    }
  },
  async post(path, params) {
    try {
      const response = await axiosInstance.post(`${path}`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response;
    } catch (error) {
      if (error.response) traduceAccessError(error.response.data);

      throw error;
    }
  },
  async put(path, params) {
    try {
      const response = await axiosInstance.put(`${path}`, params);

      return response;
    } catch (error) {
      if (error.response) traduceAccessError(error.response.data);

      throw error;
    }
  },
  async delete(path, params) {
    try {
      const response = await axiosInstance.delete(`${path}`, { data: params });

      return response;
    } catch (error) {
      if (error.response) traduceAccessError(error.response.data);

      throw error;
    }
  },
};

export { useAxios, axiosInstance };
